/* unplugin-vue-components disabled */import { render } from "./CollectUserCert.vue?vue&type=template&id=77902130&scoped=true"
import script from "./CollectUserCert.vue?vue&type=script&lang=js"
export * from "./CollectUserCert.vue?vue&type=script&lang=js"

import "./CollectUserCert.vue?vue&type=style&index=0&id=77902130&scoped=true&lang=css"

import exportComponent from "/Users/rabbuse/Project/Vue/quan-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77902130"]])

export default __exports__